import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectLMScoursesQueryItems } from '../../../../../redux/lms/courses/selector';
import { lmsCourses } from '../../../../../redux/lms/courses/action';
import PageLoader from '../../../../../components/PageLoader';
import LMSCourseComponent from '../components/course.component';


const CandidateLMSCourse = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parmas: any = useParams();
  const lmsCoursesQuery = useSelector(selectLMScoursesQueryItems);
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectLMSCourses, setSelectLMSCourses] = useState<any>({
    "title": "",
    "description": "",
    "mappedTopics": {
      "mappedTopicIds": []
    },
    "mediaMappings": {
      "mediaFiles": [],
      "templates": []
    }
  });

  const fetchLMSCoursesQueryById = () => {
    dispatch(lmsCourses.query({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/courses/query`,
      entity: 'lmsCourses',
      jsonData: {
        records: [
          {
            id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectLMSCourses({ ...selectLMSCourses, [field]: event });
  }

  useEffect(() => {
    if (parmas?.id > 0) {
      fetchLMSCoursesQueryById();
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isQuery) {
      setSelectLMSCourses(lmsCoursesQuery?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(lmsCourses.resetAction({ actionType: 'update' }))
      await dispatch(lmsCourses.update({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/courses`,
        entity: 'lmsCourses',
        jsonData: {
          records: [
            selectLMSCourses
          ]
        }
      })).then(() => {
        back();
      });
    } else {
      await dispatch(lmsCourses.resetAction({ actionType: 'create' }))
      await dispatch(lmsCourses.create({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/courses`,
        entity: 'lmsCourses',
        jsonData: {
          records: [
            selectLMSCourses
          ]
        }
      })).then(() => {
        back();
      });
    }
  }

  const back = () => {
    navigate('/candidate/lms/courses');
  }

  return (
    <>
      {lmsCoursesQuery?.isLoading ? <PageLoader /> :
        <LMSCourseComponent
          handleInnerFormChange={handleInnerFormChange}
          selectLMSCourses={selectLMSCourses}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  );
}

export default CandidateLMSCourse;
